import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";

/**
 * Create TipTap extensions configured for markdown editing
 * in the Timeline context.
 *
 * NOTE: Link and Underline are configured here but should NOT be included
 * when using the @tiptap/markdown extension, as it provides its own.
 * Use createBaseExtensions() when using Markdown extension to avoid duplicates.
 *
 * Enabled formatting:
 * - Bold, Italic, Strikethrough (via StarterKit)
 * - Underline (separate extension)
 * - Bullet lists, Ordered lists (via StarterKit)
 * - Blockquotes (via StarterKit)
 * - Horizontal rules (via StarterKit)
 * - Links (separate extension)
 *
 * Disabled:
 * - Headings (not used in timeline content)
 * - Code blocks (not used in timeline content)
 */
export const createMarkdownExtensions = (placeholder?: string) => [
  StarterKit.configure({
    heading: false, // Disabled - not used in timeline content
    codeBlock: false, // Disabled - not used in timeline content
    code: false, // Disabled - inline code not used
    // Enabled via StarterKit: bold, italic, strike, bulletList, orderedList, blockquote, horizontalRule
  }),
  Underline, // Additional mark type
  Link.configure({
    openOnClick: false, // Don't open links while editing
    HTMLAttributes: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  }),
  Placeholder.configure({
    placeholder: placeholder ?? "Enter content...",
  }),
];

/**
 * Create base extensions for use WITH @tiptap/markdown extension.
 * Excludes Link and Underline since the Markdown extension provides them.
 */
export const createBaseExtensions = (placeholder?: string) => [
  StarterKit.configure({
    heading: false,
    codeBlock: false,
    code: false,
  }),
  Placeholder.configure({
    placeholder: placeholder ?? "Enter content...",
  }),
];
